// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5187": "df9389b7","6710": "e8383776","7916": "6c873022",}[chunkId] + ".css"
}